// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CreditSummary, { CreditSummaryLayout } from "@store/Library/Components/CreditSummary";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    layout = "layout",
}

export interface CustomerCreditSummaryProps extends WidgetProps {
    fields: {
        [fields.layout]: CreditSummaryLayout;
    };
}

export interface CustomerCreditSummaryStyles {
    wrapper?: InjectableCss;
}

export const customerCreditSummaryStyles: CustomerCreditSummaryStyles = {
    wrapper: {
        css: css`
            ${x => spacingStyles(null, x.theme.design.typography.spacing.large)}
        `,
    },
};

const styles = customerCreditSummaryStyles;

const CustomerCreditSummary: FC<CustomerCreditSummaryProps> = ({ fields: { layout } }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <CreditSummary layout={layout} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomerCreditSummary,
    definition: {
        displayName: "Customer Credit Summary",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.layout,
                displayName: "Layout",
                editorTemplate: "DropDownField",
                fieldType: "Contextual",
                options: [
                    { displayName: "Grid", value: "grid" },
                    { displayName: "Stack", value: "stack" },
                ],
                defaultValue: "grid",
                hideEmptyOption: true,
            },
        ],
    },
};

export default widgetModule;
